// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CATEGORY_SELECT_NO_CATEGORIES = "Nelze vybrat \u017e\u00e1dnou kategorii ";
